import { render } from "./TodoAddButton.vue?vue&type=template&id=0456a246"
import script from "./TodoAddButton.vue?vue&type=script&lang=js"
export * from "./TodoAddButton.vue?vue&type=script&lang=js"

import exportComponent from "D:\\node projects\\jsmethod\\vue-app\\homepage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__